import { defineMessages } from 'react-intl';

/**
 * i18n messages for the CWR (Create with Rovo) welcome banner.
 *
 * The banner appears on the Confluence page that a new user lands on after
 * completing or skipping the CWR onboarding flow. It welcomes the user and
 * provides surface-specific copy (personal space, shared space, live doc, home).
 *
 * See: https://hello.jira.atlassian.cloud/browse/CCAIG-2877
 */
export const cwrWelcomeBannerMessages = defineMessages({
	bannerWelcomeMessage: {
		id: 'experiment-cwr-nth-user-onboarding.cwr-welcome-banner.heading',
		defaultMessage: 'Welcome to Confluence',
		description:
			'The text is shown as the banner title at the top of the Confluence page that a new user lands on after completing the Create with Rovo (CWR) onboarding flow. It welcomes the user and frames the page as an onboarding landing.',
	},
	bannerWelcomeMessageWithName: {
		id: 'experiment-cwr-nth-user-onboarding.cwr-welcome-banner.heading.with-name',
		defaultMessage: 'Welcome to Confluence, {firstName}',
		description:
			"The text is shown as the banner title at the top of the Confluence page that a new user lands on after completing the Create with Rovo (CWR) onboarding flow, personalized with the user's first name.",
	},
	bannerPersonalSpaceSubtext: {
		id: 'experiment-cwr-nth-user-onboarding.cwr-welcome-banner.personal-space.subtext',
		defaultMessage:
			'Use Confluence to create and share knowledge with your team. This is your personal space, a private area just for your own work and ideas.',
		description:
			'Supporting body text shown under the banner title when a new user has just completed the Create with Rovo (CWR) onboarding flow and has landed on a piece of content in their personal space.',
	},
	bannerSharedSpaceSubtext: {
		id: 'experiment-cwr-nth-user-onboarding.cwr-welcome-banner.shared-space.subtext',
		defaultMessage:
			"You've landed in a Confluence space. Use this area to build project plans, team handbooks, and anything else you want to share with the team.",
		description:
			'Supporting body text shown under the banner title when a new user has just completed the Create with Rovo (CWR) onboarding flow and has landed on a piece of content in a shared (non-personal) space.',
	},
	bannerLiveDocSubtext: {
		id: 'experiment-cwr-nth-user-onboarding.cwr-welcome-banner.live-doc.subtext',
		defaultMessage:
			'Use Confluence to create and share knowledge with your team. This is your personal space, a private area just for your own work and ideas.',
		description:
			'Supporting body text shown under the banner title when a new user has skipped the Create with Rovo (CWR) onboarding flow and has landed on a new blank live doc in their personal space.',
	},
	bannerHomeSubtext: {
		id: 'experiment-cwr-nth-user-onboarding.cwr-welcome-banner.home.subtext',
		defaultMessage:
			'Use Confluence to create and share knowledge with your team. This is your Home page, a personalized view of the latest updates from your team.',
		description:
			'Supporting body text shown under the banner title when a new user has skipped the Create with Rovo (CWR) onboarding flow and has landed on the Confluence Home page.',
	},
	bannerDismissLabel: {
		id: 'experiment-cwr-nth-user-onboarding.cwr-welcome-banner.dismiss',
		defaultMessage: 'Dismiss banner',
		description:
			'The text is used as the accessible label for the close (X) button in the top-right of the CWR welcome banner. Activating the button hides/dismisses the banner for the current view.',
	},
});
